import Vue from 'vue';
import VueRouter from 'vue-router';

import { concat } from 'lodash';

import Page404 from 'components/pages/auth/page-404';

import RouterLanding from './landing';
import RouterParticipant from './participant';
import RouterProfessional from './professional';
import RouterSystemAdministration from './system-administration';

Vue.use(VueRouter);

const routes = concat(
  RouterLanding,
  RouterParticipant,
  RouterProfessional,
  RouterSystemAdministration,
  [
    {
      path: '/403',
      name: '403',
      component: Page404,
      meta: {
        breadcrumb: '404',
      },
    },
    {
      path: '/404',
      name: '404',
      component: Page404,
      meta: {
        breadcrumb: '404',
      },
    },
    {
      path: '*',
      component: Page404,
      meta: {
        breadcrumb: '404',
      },
    },
  ],
);

console.log('routes', routes);

Vue.router = new VueRouter({ mode: 'history', routes });

export default Vue.router;



// WEBPACK FOOTER //
// ./src/router/index.js